import styled from '@emotion/styled';
import { fonts } from '@theme/fontsCustomer';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 600px;
  min-height: 364px;
  max-height: 496px;
  background-color: ${({ theme: { colors } }) => colors['bg-white']};
  border-radius: 6px;
  border: 1px solid #fff;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  min-height: 60px;
  ${fonts.Headline6};
  padding: 0px 32px;
`;

export const PriceDetail = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${props => props.theme.colors['bg-gray-light']};
  padding: 28px 32px;
  margin: 0px 32px;
  border-radius: 5px;
  height: 100%;
  gap: 8px;

  & .option-name {
    display: flex;
    flex-direction: row;
    ${fonts.Headline8};
    color: ${props => props.theme.colors['text-primary-light']};
  }

  & .option {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    ${fonts.Body1};
    align-items: center;
    & .price {
      display: flex;
      flex-direction: row;
      ${fonts.Headline4};
      color: ${props => props.theme.colors['text-primary-light']};
      align-items: center;
      & .unit {
        ${fonts.Body1};
        color: ${props => props.theme.colors['text-gray-main']};
      }
    }
  }
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
  padding: 12px 28px 32px;
`;

export const Plan = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 16px;

  & .plan-name {
    display: flex;
    flex-direction: row;
    ${fonts.Headline8};
    color: ${props => props.theme.colors['text-primary-light']};
  }
`;

export const MetricTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  border: 1px solid ${props => props.theme.colors['border-gray-lighter']};
  border-radius: 5px;
  overflow: hidden;

  th,
  td {
    padding: 12px 8px;
    text-align: left;
    ${fonts.Body1};
  }

  th {
    background-color: ${props => props.theme.colors['bg-gray-light']};
    ${fonts.Headline8};
    color: ${props => props.theme.colors['text-gray-main']};
  }

  td {
    border-top: 1px solid ${props => props.theme.colors['border-gray-lighter']};
  }

  tr:first-of-type td {
    border-top: none;
  }
`;
